import { Component, OnInit, AfterViewInit } from '@angular/core';
import {NewsService} from '../../../services/news.service';
const moment = require('moment');
moment.locale('es');

declare const twttr: any;

@Component({
  selector: 'ngx-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnInit, AfterViewInit {
  loading = false;
  readyData = false
  images = [];
  message = '';
  news = [];
  moment = moment;
  services = [];
  showTwitterFallback = false;
  
  constructor(
    private newsService: NewsService
  ) {
  }

  async ngOnInit() {
  }

  ngAfterViewInit(): void {
    if (typeof twttr !== 'undefined' && twttr.widgets) {
      twttr.widgets.load();
    }
  }
}
